import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogContent,
} from '@material-ui/core';

import { EMPTY_MAP } from 'app/app.constants';

import ApplicationHeaderBase from 'app/components/ApplicationHeader/ApplicationHeaderBase';
import AddCablesModalTable from 'features/projects/tasks/task/surfaceEquipment/components/cables/AddCablesModalTable';
import CablesFilter from 'features/equipment/cables/components/CablesFilter';

const AddCablesModal = ({
  isOpen,
  classes,
  onSubmit,
  onAddCable,
  toggleModal,
  onRemoveCable,
  initialValues,
  selectedCables,
  setSelectedCables,
  cables = EMPTY_MAP,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      PaperProps={{
        style: {
          maxHeight: '80%',
          height: '80%',
        },
      }}
      open={isOpen}
      onClose={toggleModal}
    >
      <ApplicationHeaderBase>
        <Grid container alignItems="center">
          <Grid xs item container direction="column">
            <Typography item component={Typography} variant="h6">
              Add cable
            </Typography>
          </Grid>
          <Grid item container xs justifyContent="flex-end">
            <Button color="secondary" variant="standard" onClick={toggleModal}>
              Close
            </Button>
          </Grid>
        </Grid>
      </ApplicationHeaderBase>
      <DialogContent>
        <CablesFilter onSubmit={onSubmit} initialValues={initialValues} />
        <AddCablesModalTable
          cables={cables}
          classes={classes}
          onAddCable={onAddCable}
          onRemoveCable={onRemoveCable}
          selectedCables={selectedCables}
          setSelectedCables={setSelectedCables}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddCablesModal;
